export default __webpack_public_path__ + "static/media/logo.1bf26d84.png";